import { aiWalletMenuText, walletAmount } from "./aiWalletMenu";
import "./AiWallet.css";

// What one AI operation used from the AI Wallet and what is left, as the
// backend reported it (`walletUsage` of a Copilot reply or an import draft):
//
//   Used: 1.35 SAR · Remaining: 41.15 SAR
//
// Nothing is shown when the operation was not deducted (wallet not charging
// yet) or the user may not see amounts (walletUsage null).
export default function AiWalletUsageSummary({ usage, lang = "ar", className = "" }) {
  if (!usage?.charged) return null;
  const t = aiWalletMenuText(lang);
  const used = usage.status === "pending" ? t.pending : usage.status === "released" ? `${walletAmount(0, lang)} · ${t.notCharged}` : walletAmount(usage.operationCostMinor, lang);
  return (
    <p className={`aiw-usage ${className}`} role="status" data-testid="ai-wallet-usage">
      <span>
        {t.used}: <strong dir="ltr">{used}</strong>
      </span>
      <span aria-hidden="true">·</span>
      <span>
        {t.remaining}: <strong dir="ltr">{walletAmount(usage.remainingBalanceMinor, lang)}</strong>
      </span>
    </p>
  );
}
